var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-view"},[_c('div',{staticClass:"centerBottom"},[_c('div',[_vm._v("YIBO Research & Academic Press © 2019-2025 All Right Reserved")])])])
}]

export { render, staticRenderFns }